module.exports = __webpack_public_path__ + "static/media/Flik2.bf41d857.pdf";